function initRuqyGemstoneJournal() {
  if (!document.body.classList.contains('journal-index')) return;

  const filtersRoot = document.querySelector('[data-journal-filters]');
  const grid = document.querySelector('[data-journal-grid]');

  if (!filtersRoot || !grid) return;

  const filters = filtersRoot.querySelectorAll('[data-journal-filter]');
  const cards = document.querySelectorAll('[data-journal-card]');

  filters.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.journalFilter;
      const active = filtersRoot.querySelector('[data-journal-filter].active');

      if (active === button) return;

      filters.forEach((pill) => {
        pill.classList.toggle('active', pill === button);
        pill.setAttribute('aria-pressed', pill === button ? 'true' : 'false');
      });

      grid.classList.add('fading');

      window.setTimeout(() => {
        cards.forEach((card) => {
          const cardCategory = card.dataset.category;
          const visible = category === 'all' || cardCategory === category;
          card.hidden = !visible;
        });

        grid.classList.remove('fading');
      }, 150);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRuqyGemstoneJournal);
} else {
  initRuqyGemstoneJournal();
}
